import { request } from 'Lib/axios'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

type ZendeskLoginRespons = {
  data: {
    token: string
  }
}

const getZendeskLogin = async (userId: number) =>
  request<ZendeskLoginRespons>({
    url: `users/${userId}/customer-support/auth`,
    method: 'GET',
  })

type QueryFnType = typeof getZendeskLogin

export const useGetZendeskLogin = () => {
  const { userId, isLoggedIn } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['zendeskLogin', userId],
    queryFn: () => getZendeskLogin(userId),
    enabled: !!userId && isLoggedIn,
  })

  const data = query.data instanceof Error ? undefined : query.data?.data

  return { ...query, data }
}
